import { POSITIVE, REDACT_NEGATIVE, REDACT_POSITIVE } from 'conversations-message-history/customer-agent-feedback-message/constants/messageTypes';
import { getExistingFeedback } from 'conversations-visitor-message-history/message-feedback/operators/getExistingFeedback';
// @ts-expect-error Untyped Dependency
import { getCurrentThreadHistoryData } from '../../thread-history/selectors/getCurrentThreadHistoryData';
import { getUnpublishedMessagesForCurrentThread } from '../selectors/getUnpublishedMessagesForCurrentThread';
import { publishFeedbackMessage } from './publishFeedbackMessage';
const redactOf = sentiment => sentiment === POSITIVE ? REDACT_POSITIVE : REDACT_NEGATIVE;
export const dispatchFeedbackChain = ({
  messageId,
  feedbackType
}) => (dispatch, getState) => {
  const state = getState();
  const {
    sentiment,
    latestFeedbackMessageId
  } = getExistingFeedback(messageId, getUnpublishedMessagesForCurrentThread(state), getCurrentThreadHistoryData(state));
  const redactingFeedbackMessageId = latestFeedbackMessageId !== null && latestFeedbackMessageId !== void 0 ? latestFeedbackMessageId : undefined;
  if (sentiment === null) {
    return dispatch(publishFeedbackMessage({
      messageId,
      feedbackType,
      redactingFeedbackMessageId
    }));
  }
  if (sentiment === feedbackType) {
    return dispatch(publishFeedbackMessage({
      messageId,
      feedbackType: redactOf(sentiment),
      redactingFeedbackMessageId
    }));
  }
  return dispatch(publishFeedbackMessage({
    messageId,
    feedbackType: redactOf(sentiment),
    redactingFeedbackMessageId
  })).then(redactId => {
    if (!redactId) {
      return null;
    }
    return dispatch(publishFeedbackMessage({
      messageId,
      feedbackType,
      redactingFeedbackMessageId: redactId
    }));
  });
};